const cueSet1 = [
    {
        "duration": 0.666666,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 0,
        "time": 0,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.666666,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 0,
        "time": 0,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000001,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 23040,
        "time": 0.999999,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.666666,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 30720,
        "time": 1.333332,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 53760,
        "time": 2.333331,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 61440,
        "time": 2.666664,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 84480,
        "time": 3.666663,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999998,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 92160,
        "time": 3.999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 115200,
        "time": 4.999995,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 122880,
        "time": 5.333328,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 145920,
        "time": 6.333327,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 153600,
        "time": 6.66666,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 176640,
        "time": 7.666659,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000002,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 184320,
        "time": 7.999992,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 199680,
        "time": 8.666658,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000011,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 215040,
        "time": 9.333324,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.33333299999999966,
        "durationTicks": 7680,
        "midi": 48,
        "name": "C3",
        "ticks": 238080,
        "time": 10.333323,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 245760,
        "time": 10.666656,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 245760,
        "time": 10.666656,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 268800,
        "time": 11.666655,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 276480,
        "time": 11.999988,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000011,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 299520,
        "time": 12.999986999999999,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 307200,
        "time": 13.33332,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 330240,
        "time": 14.333319,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000011,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 337920,
        "time": 14.666652,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000011,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 360960,
        "time": 15.666651,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000011,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 368640,
        "time": 15.999984,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 391680,
        "time": 16.999983,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 399360,
        "time": 17.333316,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 422400,
        "time": 18.333315,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 430080,
        "time": 18.666648,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 445440,
        "time": 19.333313999999998,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 460800,
        "time": 19.99998,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.33333299999999966,
        "durationTicks": 7680,
        "midi": 48,
        "name": "C3",
        "ticks": 483840,
        "time": 20.999979,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 491520,
        "time": 21.333312,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 491520,
        "time": 21.333312,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 514560,
        "time": 22.333311,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 522240,
        "time": 22.666643999999998,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 545280,
        "time": 23.666643,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 552960,
        "time": 23.999976,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 576000,
        "time": 24.999975,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 583680,
        "time": 25.333308,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 606720,
        "time": 26.333306999999998,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 614400,
        "time": 26.66664,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 637440,
        "time": 27.666639,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 645120,
        "time": 27.999972,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 668160,
        "time": 28.999971,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 675840,
        "time": 29.333304,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 691200,
        "time": 29.999969999999998,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 706560,
        "time": 30.666636,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.33333299999999966,
        "durationTicks": 7680,
        "midi": 48,
        "name": "C3",
        "ticks": 729600,
        "time": 31.666635,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 737280,
        "time": 31.999968,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000029,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 737280,
        "time": 31.999968,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 760320,
        "time": 32.999967,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 768000,
        "time": 33.3333,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 791040,
        "time": 34.333299,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 798720,
        "time": 34.666632,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 821760,
        "time": 35.666631,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 829440,
        "time": 35.999964,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 852480,
        "time": 36.999963,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 860160,
        "time": 37.333296,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 883200,
        "time": 38.333295,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666660000000064,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 890880,
        "time": 38.666627999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 913920,
        "time": 39.666627,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 921600,
        "time": 39.99996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 936960,
        "time": 40.666626,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 952320,
        "time": 41.333292,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.3333330000000032,
        "durationTicks": 7680,
        "midi": 48,
        "name": "C3",
        "ticks": 975360,
        "time": 42.333290999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 983040,
        "time": 42.666624,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 983040,
        "time": 42.666624,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1006080,
        "time": 43.666623,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 1013760,
        "time": 43.999956,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1036800,
        "time": 44.999955,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1044480,
        "time": 45.333287999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1067520,
        "time": 46.333287,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 1075200,
        "time": 46.66662,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1098240,
        "time": 47.666619,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 1105920,
        "time": 47.999952,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 53,
        "name": "F3",
        "ticks": 1128960,
        "time": 48.999950999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1136640,
        "time": 49.333284,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1159680,
        "time": 50.333283,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1167360,
        "time": 50.666616,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1182720,
        "time": 51.333282,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1198080,
        "time": 51.999947999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.3333330000000032,
        "durationTicks": 7680,
        "midi": 48,
        "name": "C3",
        "ticks": 1221120,
        "time": 52.999947,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1228800,
        "time": 53.33328,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 60,
        "name": "C4",
        "ticks": 1228800,
        "time": 53.33328,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1251840,
        "time": 54.333279,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 1259520,
        "time": 54.666612,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1282560,
        "time": 55.666610999999996,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1290240,
        "time": 55.999944,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1313280,
        "time": 56.999943,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 52,
        "name": "E3",
        "ticks": 1320960,
        "time": 57.333276,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.6666659999999993,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1344000,
        "time": 58.333275,
        "velocity": 0.7874015748031497
    }
];

export default cueSet1;